import React, {useRef, useState } from 'react'

//component
import CaretButton from  '@/components/elements/global/buttons/CaretButton'
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import FixedPositionContextMenu from '../lists/FixedPositionContextMenu/FixedPositionContextMenu';

//interfaces
import { WorkspaceRole } from  '@/interfaces/workspaces';
import { ISelectButton } from  '@/interfaces/selectButtonList';

//icons
import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';



const PermissionDropdown = ({id, setPermission, removePermission} : {id: number, setPermission: (id: number, setRoleAsEditor: boolean) => void, removePermission: (id: number) => void}) => {  
    const dropdownRef = useRef<any>()
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [showUndoButton, setShowUndoButton] = useState<boolean>(false);
    const dropDownItems : ISelectButton[]= [{content: "Add as Viewer", onClick: () => onClickPermission(WorkspaceRole.VIEW) }, {content: "Add as Editor", onClick: () => onClickPermission(WorkspaceRole.EDIT) }];

    function onClickPermission(permissionType: WorkspaceRole) {
        setPermission(id, permissionType === WorkspaceRole.EDIT);
        setShowUndoButton(true);
    }
    function onClickUndo() {
        removePermission(id);
        setShowUndoButton(false);
    }
    
    return(
        <div className="permission-dropdown" ref={dropdownRef}>
            {showUndoButton 
                ?   <>
                        <Icon iconName={IconLibrary.CHECK} color='#3DAF35' sizeInPx='14'/>
                        <BasicButton content={"Undo"} className={"undo-button"} ariaLabel={'Remove Permission to access this workspace.'} onButtonClick={onClickUndo} />
                    </>
            
                :   <FixedPositionContextMenu 
                        controlIsOpen={showDropdown}
                        setControlIsOpen={setShowDropdown}
                        anchorButton={
                            <CaretButton
                                content={'Select a role...'}
                                ariaLabel={'Open dropdown selection to set the user role within the workspace'}
                                onButtonClick={() => setShowDropdown(!showDropdown)}/>
                            }
                        menuButtons={dropDownItems}
                        closeOnScrollTarget='.simplebar-content-wrapper'
                        containerQuerySelector='.add-user-group-modal'
                        manualOffset={{top: 5, right: 55}}
                    />
            }
        </div>
    )
}

export default PermissionDropdown